import { Typography, Box } from '@mui/material';
import { PortfolioSentimentWidget } from '../components/widgets/PortfolioSentimentWidget';

export default function Portfolios() {
  return (
    <>
      {/* Page Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" fontWeight={700} gutterBottom>
          Portfolio Analysis
        </Typography>
        <Typography variant="body1" color="text.secondary">
          AI-powered stock sentiment with 4-quadrant strategy: STRONG_BUY • OPPORTUNITY • STRONG_SELL • BULL_TRAP
        </Typography>
      </Box>

      {/* Portfolio 4-Quadrant Chart */}
      <Box sx={{ mb: 3 }}>
        <PortfolioSentimentWidget />
      </Box>
    </>
  );
}
